import React from 'react';
import styled from 'styled-components';
import { Box, Heading, Text } from '@99designs/emu';
import { colors, typography } from '@99designs/emu/settings';
import { useIsExperimentActivated } from '@99designs/experiments';
import { ProductLandingGroupKey } from '../../../lib/productLandingGroups';

const Badge = styled.div<{ BadgeColor: string }>`
    border-radius: 100%;
    background-color: ${(props) => (props.BadgeColor ? props.BadgeColor : colors.sandyButt)};
    text-align: center;
    min-width: 50px;
    max-width: 50px;
    font-size: ${typography.typeScale.size6}px;
    font-weight: ${typography.fontWeights.bold};
    color: ${colors.grey800};
`;
const BadgeContestFocus = styled.div<{ BadgeColor: string }>`
    border-radius: 100%;
    background-color: ${(props) => (props.BadgeColor ? props.BadgeColor : colors.sandyButt)};
    text-align: center;
    min-width: 50px;
    max-width: 50px;
    font-size: ${typography.typeScale.size6}px;
    font-weight: ${typography.fontWeights.bold};
    color: ${colors.white};
`;

export interface WorkOptionProps {
    badgeColor: string;
    badgeValue: number;
    contentHeading: string;
    contentDescription: React.ReactNode;
    categoryKey?: ProductLandingGroupKey;
}

export default function HowItWorkOptions({
    badgeColor,
    badgeValue,
    contentHeading,
    contentDescription,
    categoryKey,
}: WorkOptionProps) {
    const isContestFocusEnabled =
        useIsExperimentActivated('contestCenteredHomepageHero', 'enabled') &&
        categoryKey === 'logo-design';
    return (
        <Box
            display="flex"
            flexDirection={'column'}
            paddingTop={['1bu', '1bu', '2bu', '2bu']}
            paddingRight={['none', '2bu', 'none', 'none']}
        >
            <Box
                display="flex"
                flexDirection={['column', 'column', 'row', 'row']}
                alignItems={['start', 'start', 'center', 'center']}
            >
                {isContestFocusEnabled ? (
                    <BadgeContestFocus BadgeColor={badgeColor}>{badgeValue}</BadgeContestFocus>
                ) : (
                    <Badge BadgeColor={badgeColor}>{badgeValue}</Badge>
                )}
                <Box
                    paddingLeft={['none', 'none', '1bu', '1bu']}
                    paddingTop={['0.5bu', '0.5bu', 'none', 'none']}
                >
                    <Heading appearanceLevel={4} accessibilityLevel={4}>
                        {contentHeading}
                    </Heading>
                </Box>
            </Box>
            <Box paddingTop={'0.5bu'}>
                <Text size="size3">{contentDescription}</Text>
            </Box>
        </Box>
    );
}
